import { scrollToTopOfApp } from "../../util/helper";
export const createNavigationSlice = (set, get) => ({
  currentScreen: "set-postal-code",
  navigationHistory: [],
  isTransitioning: false,
  transitionMessage: "Loading...",
  stepsMetadata: [],

  setCurrentScreen: (screen) => {
    set((state) => ({
      currentScreen: screen,
      navigationHistory: [...state.navigationHistory, state.currentScreen],
    }));
  },

  setStepsMetadata: (metadata) => {
    set({ stepsMetadata: metadata });
  },

  setIsTransitioning: (isTransitioning, message = "Loading...") => {
    set({ isTransitioning, transitionMessage: message });
  },

  goToNextScreen: async (screenName, onBeforeTransition) => {
    // Only show loading state if there's async work to do
    const hasAsyncWork = onBeforeTransition && typeof onBeforeTransition === 'function';

    if (hasAsyncWork) {
      set({ isTransitioning: true });
    }

    try {
      // Execute any async operations before transition
      if (hasAsyncWork) {
        await onBeforeTransition();
      }

      scrollToTopOfApp();
      set((state) => ({
        currentScreen: screenName,
        navigationHistory: [...state.navigationHistory, state.currentScreen],
        isTransitioning: false,
      }));
    } catch (error) {
      console.error('Error during screen transition:', error);
      set({ isTransitioning: false });
      throw error;
    }
  },

  goToPreviousScreen: () => {
    scrollToTopOfApp();
    const history = [...get().navigationHistory];
    const previous = history.pop();

    return set({
      currentScreen: previous || "set-postal-code",
      navigationHistory: history,
    });
  },

  // Jump to a specific screen (used by ProgressStepsArrow)
  // Rebuilds history up to the target screen to maintain proper back navigation
  jumpToScreen: (targetScreen) => {
    scrollToTopOfApp();
    const state = get();
    const stepsMetadata = state.stepsMetadata;

    // Find the index of the target screen in the steps sequence
    const targetIndex = stepsMetadata.findIndex(step => step.key === targetScreen);

    if (targetIndex === -1) {
      // If target not found in metadata, just use setCurrentScreen
      return state.setCurrentScreen(targetScreen);
    }

    // Rebuild history up to (but not including) the target screen
    const newHistory = stepsMetadata
      .slice(0, targetIndex)
      .map(step => step.key)
      .filter(key => key !== 'set-postal-code'); // Exclude postal code as it's the starting point

    // Add postal code at the beginning if we have any history
    if (newHistory.length > 0) {
      newHistory.unshift('set-postal-code');
    }

    set({
      currentScreen: targetScreen,
      navigationHistory: newHistory,
    });
  },

  canGoBack: () => get().navigationHistory.length > 0,
});
